<template>
  <StandardResourceService title="广告管理" :tab-list="tabList" v-model="activeTab">
    <AdvertisementListTab v-if="activeTab === 'advertisementList'"/>
  </StandardResourceService>
</template>

<script>
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'
import AdvertisementListTab from './components/AdvertisementListTab.vue'

export default {
  name: 'Advertisement',
  components: {
    StandardResourceService,
    AdvertisementListTab
  },
  data() {
    return {
      activeTab: 'advertisementList',
      tabList: [
        { label: '广告列表', key: 'advertisementList' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
